import { Button, Stack, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UseAuthPermissions } from '../../session/UseAuthPermissions';
import CreateAdminPassDialog from './CreateAdminPassDialog';
import { PassesFilter } from '../PassesFilter/PassesFilter';
import { AtRiskLocationFilter } from '../PassesFilter/AtRiskLocationFilter';

type PassesActionsProps = {
  atRiskMode?: boolean;
};

const PassesActions = ({ atRiskMode = false }: PassesActionsProps) => {
  const { t } = useTranslation();
  const { readOnly } = UseAuthPermissions();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);

  if (atRiskMode) {
    return (
      <Stack direction="row" gap={1} alignItems="center" justifyContent="flex-end">
        <AtRiskLocationFilter />
      </Stack>
    );
  }

  return (
    <Stack direction="row" gap={1} alignItems="center" justifyContent="flex-end">
      <PassesFilter />
      <Tooltip title={readOnly ? t('noPermissions') : undefined}>
        <span>
          <Button
            disabled={readOnly}
            variant="contained"
            sx={{ textTransform: 'none' }}
            onClick={() => setCreateDialogOpen(true)}>
            {t('passes.create_pass')}
          </Button>
        </span>
      </Tooltip>
      <CreateAdminPassDialog open={createDialogOpen} onClose={() => setCreateDialogOpen(false)} />
    </Stack>
  );
};

export default PassesActions;
